import React from 'react';
import clsx from 'clsx';
import { Icon, Size, Color } from '@americanexpress/aqx-components';
import styles from './__styles__/index.scss?modules';

const PillBoxIcon = ({ iconName, className }) => {
  return (
    <Icon
      className={className}
      directory="dls"
      imageName={iconName}
      $size={Size.SMX}
      theme={{
        paddingRight: 0,
        paddingLeft: 0,
        color: Color.BrightBlue
      }}
    />
  );
};

const PillboxItem = ({ filterItem, isSelected, onFilterClick }) => {
  const itemClickHandler = () => {
    if (typeof onFilterClick === 'function') {
      onFilterClick();
    }
    filterItem.onClick();
  };

  return (
    <button
      className={clsx(styles.pillboxCta, { [styles.isSelected]: isSelected })}
      onClick={itemClickHandler}
    >
      {filterItem.iconName && (
        <React.Fragment>
          <PillBoxIcon
            iconName={filterItem.iconName}
            className={styles.iconNormal}
          />
          <PillBoxIcon
            iconName={`${filterItem.iconName}-filled`}
            className={clsx(styles.iconFilled, styles[filterItem.iconName])}
          />
        </React.Fragment>
      )}
      <span className={styles.text}>{filterItem.text}</span>
    </button>
  );
};

export default React.memo(PillboxItem);
